import { delegatePackageConstants } from "@constants";

const initalState = {
  query: {
    loading: false,
    constructionUuid: null,
    condition: {},
    total: 0,
    total_wait_collect_packages: 0,
    total_delegate_recipient_packages: 0,
    total_delegate_sender_packages: 0,
    items: [],
    fail: null
  }
};

export const delegatePackages = (state = initalState, action) => {
  switch (action.type) {
    case delegatePackageConstants.GET_ALL_REQUEST:
      return {
        ...state,
        query: {
          ...initalState.query,
          loading: true
        }
      };
    case delegatePackageConstants.GET_ALL_SUCCESS:
      const {
        total,
        total_wait_collect_packages,
        total_delegate_recipient_packages,
        total_delegate_sender_packages,
        items,
        condition,
        constructionUuid
      } = action;

      /**
       * 2023-05-29
       * 後端將原物品包裹的狀態改成 history 的陣列格式，但前端畫面呈現未調整，故將後端資料轉換成前端原本的格式。
       **/

      const converedItems = items.map(item => {
        const { history } = item;

        let converedFields = history.reduce((acc, cur) => {
          const { files, status: currentStatus, note, created_at } = cur;
          switch (currentStatus) {
            case "wait_collect":
              acc["delegate_package_files"] = files;
              acc["note"] = note;
              break;
            case "collected":
              acc["collected_at"] = created_at;
              acc["collected_record_files"] = files;
              break;
            default:
              break;
          }

          return acc;
        }, {});

        return {
          ...item,
          ...converedFields
        };
      });

      return {
        ...state,
        query: {
          ...initalState.query,
          loading: false,
          constructionUuid,
          condition,
          total,
          total_wait_collect_packages,
          total_delegate_recipient_packages,
          total_delegate_sender_packages,
          items: converedItems
        }
      };
    case delegatePackageConstants.GET_ALL_FAILURE:
      const { error } = action;
      return {
        ...state,
        query: {
          ...initalState.query,
          loading: false,
          fail: error
        }
      };
    case delegatePackageConstants.RESET_ALL_SUCCESS:
      return initalState;
    default:
      return state;
  }
};
